export const TLDRAW_WORKER_URL = "https://whiteboard-core.simulanis.co.in"
// export const TLDRAW_WORKER_URL = "http://localhost:5172"